import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UserManagementService } from '../../../core/services/user-management.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { ConfirmationModalService, ModalTemplateComponent } from '@nx-ahs/shared/components';

@Component({
	selector: 'app-download-users',
	templateUrl: './download-users.component.html',
	styleUrls: ['./download-users.component.scss'],
	standalone: true,
	imports: [CommonModule, FormsModule, MatSlideToggleModule, ModalTemplateComponent]
})
export class DownloadUsersComponent implements OnInit {
	public activeOnly: boolean = false;
	public downloading: boolean;

	constructor(
		private userManagementService: UserManagementService,
		private snackBar: MatSnackBar,
		private dialogRef: MatDialogRef<DownloadUsersComponent>,
		private confirmationModalService: ConfirmationModalService
	) {}

	ngOnInit() {
		this.dialogRef.keydownEvents().subscribe((event) => {
			if (event.key === 'Escape') {
				this.cancel();
			}
		});
		this.dialogRef.backdropClick().subscribe(() => {
			this.cancel();
		});
	}

	public downloadFile(): void {
		this.downloading = true;
		this.userManagementService.downloadUsers(this.activeOnly).finally(() => {
			this.downloading = false;
			this.snackBar.open('Your file is downloading.', 'DISMISS', { duration: 5000 });
			this.dialogRef.close();
		});
	}

	public cancel(): void {
		this.confirmationModalService
			.showConfirmationDialog('Confirm Cancel', 'Click OK to continue')
			.beforeClosed()
			.toPromise()
			.then((result) => {
				if (result) {
					this.dialogRef.close(undefined);
				}
			});
	}
}
